import postAPI from './postAPI.js'

export default async function postUpdateStep(stepData) {
    const data = await postAPI('admin/taskflows/steps/update', stepData);
    return data;
}
